import { Typography } from 'seagull';
import { AnchorIcon } from 'seagull/icons';
import React from 'react';
import { QboIcon } from "../QboIcon";
import styles from "./MapServicesModal.module.scss";
export const columnDefs = [{
  width: 400
},
// Anchor service
{
  width: 400
},
// QuickBooks item names
{
  width: 260
} // Status
];
export const headerItems = [{
  value: /*#__PURE__*/React.createElement("div", {
    className: styles.columnHeader
  }, /*#__PURE__*/React.createElement(AnchorIcon, {
    className: styles.icon
  }), /*#__PURE__*/React.createElement(Typography, {
    variant: "paragraph2"
  }, "Anchor service name"))
}, {
  value: /*#__PURE__*/React.createElement("div", {
    className: styles.columnHeader
  }, /*#__PURE__*/React.createElement(QboIcon, null), /*#__PURE__*/React.createElement(Typography, {
    variant: "paragraph2"
  }, "QuickBooks Online service name"))
}, {
  value: 'Status'
}];
export function getSearchedServicesAndFilteredOptions(_ref) {
  let {
    services,
    search,
    statusFilters
  } = _ref;
  const searchFilteredServices = services.filter(service => applySearch({
    search,
    service
  }));
  const serviceFilterOptions = getServiceFilterOptions({
    services: searchFilteredServices
  });
  const filteredServices = searchFilteredServices.filter(service => applyServiceFilterMappingStatus({
    filters: statusFilters,
    service
  }));
  return {
    filteredServices,
    serviceFilterOptions
  };
}
export function applySearch(_ref2) {
  let {
    search,
    service
  } = _ref2;
  const normalizedSearch = search ? search.trim().toLowerCase() : search;
  const serviceName = service.name.toLowerCase();
  return !normalizedSearch || "".concat(serviceName).includes(normalizedSearch);
}
export function applyServiceFilterMappingStatus(_ref3) {
  let {
    filters,
    service
  } = _ref3;
  return filters.length === 0 || filters.some(status => status === 'mapped' && service.integratedId != null || status === 'notMapped' && service.integratedId == null);
}
export function getServiceFilterOptions(_ref4) {
  let {
    services
  } = _ref4;
  return services.reduce((acc, service) => {
    const status = getServiceMappingStatus(service);
    const existingStatusEntry = acc.findIndex(option => option.value === status);
    if (existingStatusEntry >= 0) {
      acc[existingStatusEntry].counter = (acc[existingStatusEntry].counter || 0) + 1;
    } else {
      acc.push({
        value: status,
        counter: 1,
        label: status === 'mapped' ? 'Yes' : 'No'
      });
    }
    return acc;
  }, []);
}
export function getServiceMappingStatus(service) {
  return service.integratedId ? 'mapped' : 'notMapped';
}